import {
  DATA_ROOM_NDA_SIGNING_STATUS,
  DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION,
  DataRoomNdaSigningStatus,
  DataRoomNdaSigningTimelineAction,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';

export const NDA_SIGNING_TRACK_EVENTS_COPY: Record<
  DataRoomNdaSigningTimelineAction,
  string
> = {
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.SENT]: 'NDAsentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.SIGNED]: 'userSignedNDA',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.REMINDER]: 'NDAreminderSentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.REJECTED]: 'userRejectedNDA',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.COUNTER_SENT]: 'NDAsentToUser',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.COUNTER_SIGNED]: 'userSignedNDA',
  [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.MANUALLY_UPDATED]:
    'NDAmanuallyUpdated',
};

export const NDA_SIGNING_STATUS_COPY: Record<DataRoomNdaSigningStatus, string> =
  {
    [DATA_ROOM_NDA_SIGNING_STATUS.PENDING]: 'sentNDAStatus',
    [DATA_ROOM_NDA_SIGNING_STATUS.NDA_EXECUTED]: 'signedNDAStatus',
    [DATA_ROOM_NDA_SIGNING_STATUS.COUNTER_SIGNATURE_PENDING]:
      'ndaCounterPendingStatus',
    [DATA_ROOM_NDA_SIGNING_STATUS.REJECTED]: 'ndaRejectedStatus',
    [DATA_ROOM_NDA_SIGNING_STATUS.NOT_SENT]: 'notSentNDAStatus',
  };
